export const INDIAN_STATES = [
  'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
  'Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh',
  'Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan',
  'Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal',
  'Delhi','Jammu and Kashmir','Ladakh','Chandigarh','Puducherry','Andaman and Nicobar','Other',
];

export const GST_STATE_CODES = {
  '01':'Jammu & Kashmir','02':'Himachal Pradesh','03':'Punjab','04':'Chandigarh',
  '05':'Uttarakhand','06':'Haryana','07':'Delhi','08':'Rajasthan','09':'Uttar Pradesh',
  '10':'Bihar','11':'Sikkim','12':'Arunachal Pradesh','13':'Nagaland','14':'Manipur',
  '15':'Mizoram','16':'Tripura','17':'Meghalaya','18':'Assam','19':'West Bengal',
  '20':'Jharkhand','21':'Odisha','22':'Chhattisgarh','23':'Madhya Pradesh','24':'Gujarat',
  '25':'Dadra & Nagar Haveli and Daman & Diu','26':'Dadra & Nagar Haveli and Daman & Diu',
  '27':'Maharashtra','28':'Andhra Pradesh (Old)','29':'Karnataka','30':'Goa',
  '31':'Lakshadweep','32':'Kerala','33':'Tamil Nadu','34':'Puducherry',
  '35':'Andaman & Nicobar Islands','36':'Telangana','37':'Andhra Pradesh',
  '38':'Ladakh','97':'Other Territory','99':'Centre Jurisdiction',
};

// Returns { code, state } from a GSTIN, or null if GSTIN is empty/invalid
export function deriveFromGstin(gstin) {
  if (!gstin || gstin.length < 2) return null;
  const code = gstin.slice(0, 2).toUpperCase();
  const state = GST_STATE_CODES[code];
  if (!state) return null;
  return { code, state };
}

// GSTIN format: 2 digits + 5 alpha + 4 digits + 1 alpha + 1 digit + Z + 1 alphanum
const GSTIN_RE = /^\d{2}[A-Z]{5}\d{4}[A-Z]\d[Z][A-Z\d]$/i;

export function validateGstin(gstin) {
  if (!gstin || gstin.trim() === '') return { valid: true, error: null }; // empty = unregistered, allowed
  const g = gstin.trim().toUpperCase();
  if (g.length !== 15) return { valid: false, error: 'GSTIN must be 15 characters' };
  if (!GSTIN_RE.test(g)) return { valid: false, error: 'Invalid GST Number' };
  const code = g.slice(0, 2);
  if (!GST_STATE_CODES[code]) return { valid: false, error: `Unknown GST state code: ${code}` };
  return { valid: true, error: null };
}

export function getTaxType(sellerStateCode, buyerStateCode) {
  if (!buyerStateCode) return 'interstate';
  return sellerStateCode === buyerStateCode ? 'intrastate' : 'interstate';
}

export function calcGST(baseAmount, gstPercent, sellerStateCode, buyerStateCode) {
  const taxType = getTaxType(sellerStateCode, buyerStateCode);
  const totalTax = parseFloat(((baseAmount * gstPercent) / 100).toFixed(2));
  if (taxType === 'intrastate') {
    const half = parseFloat((totalTax / 2).toFixed(2));
    return { taxType, cgst: half, sgst: totalTax - half, igst: 0, totalTax, totalWithTax: baseAmount + totalTax };
  }
  return { taxType, cgst: 0, sgst: 0, igst: totalTax, totalTax, totalWithTax: baseAmount + totalTax };
}

export function calcInvoiceTotals(items, sellerStateCode, buyerStateCode) {
  let subtotal=0, cgst=0, sgst=0, igst=0;
  const taxType = getTaxType(sellerStateCode, buyerStateCode);
  items.forEach(({ baseAmount, gstPercent }) => {
    const t = calcGST(baseAmount, gstPercent, sellerStateCode, buyerStateCode);
    subtotal += baseAmount; cgst += t.cgst; sgst += t.sgst; igst += t.igst;
  });
  const totalTax = parseFloat((cgst+sgst+igst).toFixed(2));
  return { taxType, subtotal: parseFloat(subtotal.toFixed(2)), cgst: parseFloat(cgst.toFixed(2)), sgst: parseFloat(sgst.toFixed(2)), igst: parseFloat(igst.toFixed(2)), totalTax, grandTotal: parseFloat((subtotal+totalTax).toFixed(2)) };
}

export const fmt = n => '₹' + Math.round(n).toLocaleString('en-IN');
export const initials = n => n?.split(' ').map(x=>x[0]).join('').toUpperCase().slice(0,2) || '?';
